import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const PatientVitalService = {
  getPatientVitalsList(params){ return axiosRequest('GET', API_PATH.PATIENT_VITAL.LIST(params)) },
  getPatientVital(data){ return axiosRequest('POST', API_PATH.PATIENT_VITAL.INFO, data) },
  addPatientVital(data){ return axiosRequest('POST', API_PATH.PATIENT_VITAL.ADD, data) },
  deletePatientVital(data){ return axiosRequest('POST', API_PATH.PATIENT_VITAL.DELETE, data) },
  getPatientVitalChartsData(params){ return axiosRequest('GET', API_PATH.PATIENT_VITAL.CHART(params)) },
}